// 登录页（M0 占位）
import { useState } from 'react';
import { Card, Form, Input, Button, Tabs, App as AntApp, Typography, Tag } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { api, setToken, setStoredUser } from '../lib/api';

const { Title, Text } = Typography;

export default function LoginPage({ onLogin }: { onLogin?: () => void }) {
  const { message } = AntApp.useApp();
  const [mode, setMode] = useState<'login' | 'register'>('login');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [form] = Form.useForm();

  const onSubmit = async (values: { username: string; password: string }) => {
    setLoading(true);
    setError(null);
    try {
      const r = mode === 'login'
        ? await api.login(values.username, values.password)
        : await api.register(values.username, values.password);
      setToken(r.token);
      setStoredUser(r.user);
      message.success(`${mode === 'login' ? '登录' : '注册'}成功！`);
      onLogin?.();
      form.resetFields();
    } catch (err: any) {
      const msg = err.message || '操作失败';
      setError(msg); // 内联兜底（即便 message 通知失效也能看见）
      try { message.error(msg); } catch { /* message context 可能失效，吞掉 */ }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: 16,
      }}
    >
      <Card style={{ width: 400, background: '#161b22', borderColor: '#30363d' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <Title level={2} style={{ color: '#fff', marginBottom: 4 }}>
            🏴‍☠️ 黑哥们各股跌
          </Title>
          <Text style={{ color: '#8b949e' }}>娱乐版 v0.1.0 · 网页版</Text>
          <div style={{ marginTop: 8 }}>
            <Tag color="warning">仅供娱乐</Tag>
          </div>
        </div>
        <Tabs
          activeKey={mode}
          onChange={(k) => setMode(k as 'login' | 'register')}
          centered
          items={[
            { key: 'login', label: '登录' },
            { key: 'register', label: '注册' },
          ]}
        />
        <Form form={form} layout="vertical" onFinish={onSubmit}>
          {error && (
            <div
              role="alert"
              style={{
                background: 'rgba(255, 77, 79, 0.1)',
                border: '1px solid #ff4d4f',
                borderRadius: 4,
                padding: 8,
                marginBottom: 12,
                color: '#ff4d4f',
                fontSize: 12,
              }}
            >
              ⚠️ {error}
            </div>
          )}
          <Form.Item
            name="username"
            label="用户名"
            rules={[
              { required: true, message: '请输入用户名' },
              { min: 3, max: 20, message: '长度 3-20 字符' },
              { pattern: /^[a-zA-Z0-9_-]+$/, message: '只能含字母、数字、下划线、短横线' },
            ]}
          >
            <Input prefix={<UserOutlined />} placeholder="3-20 字符" autoComplete="username" />
          </Form.Item>
          <Form.Item
            name="password"
            label="密码"
            rules={[
              { required: true, message: '请输入密码' },
              { min: 6, message: '至少 6 位' },
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="至少 6 位"
              autoComplete={mode === 'login' ? 'current-password' : 'new-password'}
            />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block loading={loading}>
              {mode === 'login' ? '登录' : '注册并登录'}
            </Button>
          </Form.Item>
        </Form>
        <div style={{ textAlign: 'center', color: '#8b949e', fontSize: 11, marginTop: 8 }}>
          ⚠️ 所有账户余额、交易、黑哥们事件均为模拟
        </div>
      </Card>
    </div>
  );
}